import * as React from "react";
export const SvgDashboard = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
		<path
			stroke={props.color ?? "#A8A8A8"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="m2.297 7.45 7.65-5.95 7.65 5.95v9.35a1.7 1.7 0 0 1-1.7 1.7h-11.9a1.7 1.7 0 0 1-1.7-1.7V7.45Z"
			clipRule="evenodd"
		/>
		<path
			stroke={props.color ?? "#A8A8A8"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M7.398 18.5V10h5.1v8.5"
		/>
	</svg>
);
